var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalCommon',{attrs:{"id":`ModalPreviewPartner`,"config":_vm.config,"isView":true},on:{"close":_vm.handleClose}},[_vm._t("default")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }